import React from 'react'
import OneProductDiscountContainer from '../../../../../Components/DiscountPart/CreateDiscountContainer/OneProductDiscountContainer/OneProductDiscountContainer'
import Layout from '../../../Layout'
const OneProductDiscount = () => {
  return (
    <Layout>
        <OneProductDiscountContainer/>
    </Layout>
  )
}

export default OneProductDiscount